'use client'
import { createContext, useContext } from 'react'

import { MobileNavigationProviderValueProps } from '@maestro/commerce-blocks/providers/mobile-navigation/types'

const initialValue: MobileNavigationProviderValueProps = {
  isOpen: false,
  openMenu: () => {
    throw new Error('Not implemented')
  },
  closeMenu: () => {
    throw new Error('Not implemented')
  },
  activeNodeIds: [],
  openLevel: () => {
    throw new Error('Not implemented')
  },
  openLevelAt: () => {
    throw new Error('Not implemented')
  },
  closeLevel: () => {
    throw new Error('Not implemented')
  },
  isActive: () => {
    throw new Error('Not implemented')
  },
  isChildActive: () => {
    throw new Error('Not implemented')
  },
}

export const MobileNavigationContext = createContext(initialValue)

export const useMobileNavigation = () => useContext(MobileNavigationContext)
